import { render, staticRenderFns } from "./KeyProjectTypes.vue?vue&type=template&id=5b4213b6"
import script from "./KeyProjectTypes.vue?vue&type=script&lang=js"
export * from "./KeyProjectTypes.vue?vue&type=script&lang=js"
import style0 from "./KeyProjectTypes.vue?vue&type=style&index=0&id=5b4213b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports